import React from 'react';
import ImageGallery from '@/components/ui/ImageGallery';
import PageBanner from '@/components/ui/PageBanner';
import '@/pages/ventures/Venture.scss';
import main from '@/assets/art.jpeg';
import a1 from '@/assets/arts/1.jpeg';
import a2 from '@/assets/arts/2.png';
import a3 from '@/assets/arts/3.png';
import a5 from '@/assets/arts/5.png';
import BodyMotion from '@/components/ui/BodyMotion';
import { SiInstagram as Ig } from '@icons-pack/react-simple-icons';

const EphemeraFoundation: React.FC = () => {
  const hardCodedImages = [
    {
      src: a1,
      width: 8,
      height: 4,
      title: 'Chiel van Zelst',
      link: 'https://www.instagram.com/chiel_van_zelst',
    },
    {
      src: a3,
      width: 5,
      height: 4,
      title: 'Desiree Dolron',
      link: 'https://www.instagram.com/desireedolronstudio',
    },
    {
      src: a5,
      width: 5,
      height: 6,
      title: 'Irene Hoff',
      link: 'https://www.instagram.com/art_irenehoff',
    },
    {
      src: a2,
      width: 8,
      height: 4,
      title: 'Arie Hellendoorn',
      link: 'https://www.instagram.com/ariehellendoorn',
    }
  ];

  return (
    <main className="venture-page">
      <PageBanner title="The Ephemera Foundation" image={main} />
      <section className="venture-page__content">
        <BodyMotion>
          <p>
            We are proud to support The Ephemera Foundation, a non-profit established by our
            principals to support unique human artistic insight. In a world flooded with artificial
            imagery, authentic human creative expression has never been more important.
          </p>
          <p>
            We partner with vital cultural institutions in each of our locations and with select
            individual artists in furtherance of the Foundation's objectives to showcase human
            creativity. The Foundation reflects a personal conviction held independently of any commercial consideration - established and funded by our principals, with no relationship to investor capital or returns.
          </p>
        </BodyMotion>
      </section>
      <div className="venture-page__photoalbum">
        <ImageGallery images={hardCodedImages} defaultIcon={Ig} />
      </div>
      <section className="venture-page__content">
        <BodyMotion>
          <p>
            The Foundation operates exclusively in furtherance of its stated cultural objectives and
            does not pursue commercial or profit-seeking activities.The activities of the Foundation
            are not undertaken for the benefit of, and are not intended to generate value for, any
            investors or investment vehicles.
          </p>
          <h4>Legal Status</h4>
          <p>
            The Ephemera Foundation is an independent foundation (stichting) established under the
            laws of the Netherlands. It has no members or shareholders, does not distribute profits,
            and applies its assets solely toward the achievement of its statutory purposes, as set
            out in its deed of incorporation.
          </p>
          <h4>Relationship to Ephemera Partners</h4>
          <p>
            The Ephemera Foundation is legally, financially, and operationally separate from
            Ephemera Partners, L.P. and from any affiliated investment vehicles or management
            entities. The foundation:
          </p>
          <ul>
            <li>does not raise capital;</li>
            <li>does not offer, solicit, or facilitate investments;</li>
            <li>does not manage assets on behalf of investors;</li>
            <li>
              does not engage in activities subject to investment fund or investment adviser
              regulation.
            </li>
          </ul>
          <p>
            Any interaction between the Foundation and Ephemera Partners is conducted on an
            arm’s-length basis and in accordance with applicable law.
          </p>
          <h4>Activities</h4>
          <p>The activities of the Foundation may include, without limitation:</p>
          <ul>
            <li>supporting, commissioning, or exhibiting artistic works;</li>
            <li>promoting cultural initiatives and exchanges;</li>
            <li>providing non-commercial platforms for creative expression;</li>
            <li>
              collaborating with artists and cultural institutions consistent with its mission.
            </li>
          </ul>
          <p>
            The Foundation operates exclusively in furtherance of its stated cultural objectives and
            does not conduct trading, commercial, or profit-generating activities.
          </p>
          <h4>Governance</h4>
          <p>
            The Ephemera Foundation is governed by a board responsible for overseeing its affairs
            and ensuring compliance with Dutch law and the Foundation’s constitutional objectives.
            The board exercises independent judgment and is accountable for the strategic direction,
            stewardship, and lawful operation of the Foundation.
          </p>
          <h4>Regulatory Position</h4>
          <p>
            The Ephemera Foundation is not an investment vehicle and does not fall within the scope
            of U.S., EU, or other securities, investment fund, or investment adviser regulation.
            Nothing on this website relating to the Foundation constitutes an offer, solicitation,
            or financial promotion of any kind.
          </p>
        </BodyMotion>
      </section>
    </main>
  );
};

export default EphemeraFoundation;
